module.exports = __webpack_public_path__ + "img/pic_3_tc_new.e413c5b6.png";